import { Crs } from "@evergis/sgis/es/Crs";
import { Poly } from "@evergis/sgis/es/features/Poly";
import { simplifyCoordinates } from "@evergis/sgis/es/utils/math";

export const getSimplifiedPolygonCoordinates = (feature: Poly, crs: Crs, tolerance = 1) => {
  const projected = feature.crs.equals(crs) ? feature.rings : feature.projectTo(crs).rings;

  return simplifyCoordinates(projected, tolerance);
};
